import React from 'react';
import styles from './../styles/Main.module.css'; // CSS Module 사용
import One from './section/One';
import Two from './section/Two';

const Main = () => {

  // const oneRef = useRef(null);
  // const twoRef = useRef(null);

  // const sectionRefs = {
  //   One: oneRef,
  //   Two: twoRef,
  // }
  // const [activeIdx, setActiveIdx] = useState(0);

  return (

    <>
       {/* 왼쪽 인디케이터 */}
       {/* <div className={styles.indicatorContainer}>
          <div 
              className={`${styles.indicator}`}
            >
              <div className={styles.dot} />
              <span>ONE</span>
          </div>
          <div 
              className={`${styles.indicator}`}
            >
              <div className={styles.dot} />
              <span>TWO</span>
          </div>
      </div> */}

      <div className={styles.container}>
          <One />
          <Two />
          {/* <Three /> */}
      </div>
    </>
  );
};

export default Main;
